import {pageInfo} from '../api';
import {plant} from '../../../../../api'

const driverFaceRecord = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => {
        // 图片状态颜色
        if (item.facePicStatusDesc === '废弃') {
          item.facePicStatusDescColor = '#F56C6C';
        } else if (item.facePicStatusDesc === '有效') {
          item.facePicStatusDescColor = '#67C23A';
        } else {
          item.facePicStatusDescColor = '#909399';
        }
        return {...item, btns: [true]};
      });
    },
    PLANT(state, data) {
      state.plantObj = data;
    }
  },
  actions: {
    //查询人脸识别记录
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    }
  }
}
export default driverFaceRecord



// WEBPACK FOOTER //
// ./src/page/int/face/driverFaceRecord/store/driverFaceRecord.store.js